<template>
  <IntContentContainer>
    <div :class="['flex', 'flex-col', imageSide === 'right' ? 'md:flex-row-reverse' : 'md:flex-row', 'items-center', 'gap-4', 'md:gap-0', cssBackgroundClass]">
      <div class="md:basis-1/2">
        <slot name="picture"></slot>
      </div>

      <IntContentContainer :fluid="true" class="prose py-6 md:basis-1/2">
        <slot></slot>
      </IntContentContainer>
    </div>
  </IntContentContainer>
</template>

<script>
  import IntContentContainer from '../content-container'
  
  export default {
    name: 'IntMediaSection',
  
    components: { IntContentContainer },
  
    props: {
      imageSide: {
        type: String, default: 'left',
        validator(value) {
          return ['left', 'right'].includes(value)
        }
      },
      background: {
        type: String,
        validator(value) {
          return ['white', 'gray', 'black'].includes(value)
        }
      }
    },

    computed: {
      cssBackgroundClass() {
        switch (this.background) {
          case "black": return 'bg-black/50'
          case "gray": return 'bg-gray-100'
          case "white": return 'bg-white'
          default: return ''
        }
      }
    }
  }
</script>